import * as React from "react";
import { withRouter } from "react-router-dom";
import { Button, Grid, Header } from "semantic-ui-react";
import error from "../../images/error.png";
import logo from "../../images/logo-blue.png";

const ErrorComponent = ({
  authUser,
  orgId,
  history,
}: {
  [key: string]: any;
}) => (
  <Grid textAlign="center" className="signin-page">
    <Grid.Column style={{ maxWidth: 800 }}>
      <img alt="MetricSquare Logo" src={logo} style={{ width: "250px" }} />
      <img src={error} alt="MetricSquare Error image" />
      <Header as="h1">Error. We can’t find the page you’re looking for.</Header>
      <Button
        content="Go Back"
        primary={true}
        positive={true}
        onClick={() => history.go(-1)}
      />
      <Button
        content="Home"
        primary={true}
        positive={true}
        onClick={() => history.push("/")}
      />
    </Grid.Column>
  </Grid>
);

const Error = withRouter(ErrorComponent);
export default Error;



// WEBPACK FOOTER //
// ./src/containers/Error/index.tsx